var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuPartners(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.9979 5.96675C14.9479 5.95842 14.8896 5.95842 14.8396 5.96675C13.6896 5.92508 12.7729 4.98342 12.7729 3.81675C12.7729 2.62508 13.7313 1.66675 14.9229 1.66675C16.1146 1.66675 17.0729 2.63342 17.0729 3.81675C17.0646 4.98342 16.1479 5.92508 14.9979 5.96675Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.1397 12.0333C15.2814 12.225 16.5398 12.025 17.4231 11.4333C18.5981 10.65 18.5981 9.36664 17.4231 8.58331C16.5314 7.99164 15.2564 7.79163 14.1147 7.99163",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.97295 5.96675C5.02295 5.95842 5.08128 5.95842 5.13128 5.96675C6.28128 5.92508 7.19795 4.98342 7.19795 3.81675C7.19795 2.62508 6.23962 1.66675 5.04795 1.66675C3.85628 1.66675 2.89795 2.63342 2.89795 3.81675C2.90628 4.98342 3.82295 5.92508 4.97295 5.96675Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.83109 12.0333C4.68942 12.225 3.43109 12.025 2.54775 11.4333C1.37275 10.65 1.37275 9.36664 2.54775 8.58331C3.43942 7.99164 4.71442 7.79163 5.85609 7.99163",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 12.1916C9.9499 12.1833 9.89157 12.1833 9.84157 12.1916C8.69157 12.1499 7.7749 11.2083 7.7749 10.0416C7.7749 8.84994 8.73323 7.8916 9.9249 7.8916C11.1166 7.8916 12.0749 8.85827 12.0749 10.0416C12.0666 11.2083 11.1499 12.1583 9.9999 12.1916Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5751 14.8166C6.4001 15.5999 6.4001 16.8832 7.5751 17.6666C8.90843 18.5582 11.0918 18.5582 12.4251 17.6666C13.6001 16.8832 13.6001 15.5999 12.4251 14.8166C11.1001 13.9332 8.90843 13.9332 7.5751 14.8166Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPartners);
export default __webpack_public_path__ + "static/media/menuPartners.a1592f0a6290cbc7c29630a598dcae8e.svg";
export { ForwardRef as ReactComponent };